import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import { equals, map, pipe, uniqBy, prop } from "ramda";
import { Select } from "@interdependence-ui";
import { sort } from "utils/sort";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
export default /*#__PURE__*/memo(function SelectAgeSpan(props) {
  var selected = props.selected,
    ages = props.ages,
    _onChange = props.onChange;
  var total = [{
    id: "Total",
    label: "Totalt"
  }];
  var options = pipe(map(function (age) {
    return {
      id: age,
      label: age
    };
  }), function (x) {
    return total.concat(x);
  }, uniqBy(prop("id")))(ages);
  var sortedOptions = sort(function (option) {
    return option.label;
  }, options);
  return /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({
    id: "select-agespan",
    label: "Visa data f\xF6rdelat p\xE5 \xE5lder",
    hideLabel: true
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    selectedPrefix: /*#__PURE__*/_jsx("strong", {
      children: "\xC5lder:\xA0"
    }),
    _selected: sortedOptions.findIndex(function (option) {
      return equals(option.id, selected);
    }),
    options: sortedOptions,
    onChange: function onChange(idx) {
      return _onChange(sortedOptions[idx].id);
    }
  }), sortedOptions);
}, function (curr, prev) {
  return equals(curr.selected, prev.selected) && equals(curr.ages, prev.ages) && equals(curr.onChange, prev.onChange);
});